<template>
    <div>
        <rkm-tabs>
            <rkm-tab title="Base Nacional">
                <TabBaseNacional
                    ref="TabBaseNacional"
                    @select="handleSelect"
                />
            </rkm-tab>

            <rkm-tab title="Base Local">
                <TabBaseLocal
                    ref="TabBaseLocal"
                    @select="handleSelect"
                />
            </rkm-tab>
        </rkm-tabs>
    </div>
</template>
<script>

import TabBaseNacional from './tabs/BaseNacional.vue'
import TabBaseLocal from './tabs/BaseLocal.vue'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { TabBaseNacional, TabBaseLocal },
    ...mapActions(['setLoading', 'unsetLoading']),
    methods:{
        handleSelect(logradouro){
            this.$emit('exit', logradouro)
        },

        handleSave(){
            this.$refs.TabBaseNacional.save()
        }
    },

}
</script>